import { render } from "./GifGallery.vue?vue&type=template&id=505485cc"
import script from "./GifGallery.vue?vue&type=script&lang=js"
export * from "./GifGallery.vue?vue&type=script&lang=js"

import "./GifGallery.vue?vue&type=style&index=0&id=505485cc&lang=scss"
script.render = render

export default script